import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
const googleMapAPIkey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string;
import { Libraries, LoadScript } from '@react-google-maps/api';

function App() {
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevents form submission or unwanted navigation
    }
  });
  

  const libraries: Libraries = ['places'];
  return (
    <AppProvider>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={libraries}
      >
        <AppRoutes />
      </LoadScript>
    </AppProvider>
  );
}

export default App;
